import { useState } from "react";
import { styled } from "styled-components";

import { usePutProfileMutation } from "api/profileApi.slice";
import { Spinner, UISwitch } from "common/components";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { ModalHeader } from "domains/modal/components/ModalHeader";
import { getUser } from "entities/user/selectors";
import { userSlice } from "entities/user/user.slice";

const StyledMessage = styled.p`
  margin: 0 0 1rem 0;
  color: ${({ theme }) => theme.colors.textBright};
  font-weight: bold;
`;

const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.textBright};
  margin-bottom: 3rem;
`;

const StyledInnerRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledToggleLabel = styled.p`
  font-size: 1rem;
  display: inline-block;
  margin: 0;
`;

const StyledLoadingIndicator = styled(Spinner)`
  width: 20px;
  height: 20px;
  margin-right: 15px;
`;

export const NotificationsSettingsModal = () => {
  const dispatch = useDispatch();
  const [putProfile] = usePutProfileMutation();
  const user = useSelector(getUser);
  const translate = useTranslate();

  const [isOn, setIsOn] = useState<boolean>(user?.notifications.email ?? false);

  const isLoadingUser = user === undefined;

  const onClick = () => {
    if (user === undefined) return;
    const email = !isOn;
    setIsOn(email);
    dispatch(userSlice.actions.setNotificationsEmail(email));
    putProfile({ body: { ...user, notifications: { email } }, user_id: user.ext_id })
      .unwrap()
      .catch(() => {
        setIsOn(!email);
        dispatch(userSlice.actions.setNotificationsEmail(!email));
      });
  };

  return (
    <>
      <ModalHeader title={translate("app.settings.title")} />
      <StyledMessage>{translate("app.notification.settings.message")}</StyledMessage>
      <StyledRow>
        <StyledToggleLabel>{translate("app.notifications.settings.email")}</StyledToggleLabel>
        <StyledInnerRow>
          {isLoadingUser && <StyledLoadingIndicator />}
          <UISwitch isOn={isOn} onClick={onClick} isDisabled={isLoadingUser} />
        </StyledInnerRow>
      </StyledRow>
    </>
  );
};
